import React from 'react';
import { Reveal } from '../Reveal';

export interface StatsCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  change?: {
    value: number;
    isPositive: boolean;
  };
  delay?: number;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  icon,
  label,
  value,
  change,
  delay = 0,
}) => {
  return (
    <Reveal variant="fade-up" delay={delay}>
      <div className="liquid-glass rounded-xl p-4 hover:border-primary-500/30 transition-colors">
        <div className="flex items-start justify-between">
          <div className="w-10 h-10 bg-primary-500/20 rounded-lg flex items-center justify-center text-primary-400">
            {icon}
          </div>

          {change && (
            <span
              className={`
                text-xs font-medium px-2 py-0.5 rounded-md
                ${change.isPositive
                  ? 'text-green-400 bg-green-500/10'
                  : 'text-red-400 bg-red-500/10'
                }
              `}
            >
              {change.isPositive ? '+' : ''}{change.value}%
            </span>
          )}
        </div>

        <div className="mt-3">
          <p className="text-neutral-400 text-xs">{label}</p>
          <p className="text-2xl font-bold text-white mt-0.5">{value}</p>
        </div>
      </div>
    </Reveal>
  );
};
